export const ROUTE_MODULE = {
  "/payroll": "payroll", "/payslips": "payroll", "/change-requests": "payroll", "/direct-deposit": "payroll",
  "/employees": "employees", "/hr": "employees",
  "/scheduling": "time_attendance",
  "/leave": "leave",
  "/hiring": "hiring", "/offers": "hiring",
  "/announcements": "announcements",
  "/tax-impound": "tax",
  "/year-end": "reports", "/reports": "reports",
  "/invoices": "invoices",
  "/access": "settings",
};

export const MODULE_LABEL = {
  payroll: "Payroll", employees: "Employees", time_attendance: "Scheduling & Time", leave: "Leave", hiring: "Hiring",
  announcements: "Messages", tax: "Tax & Compliance", reports: "Reports & Year End", invoices: "Invoices", settings: "Company Settings & Access",
};

export const moduleFor = (path) => {
  const hit = Object.keys(ROUTE_MODULE).find((p) => path === p || path.startsWith(p + "/"));
  return hit ? ROUTE_MODULE[hit] : null;
};

export const isCustomRole = (user) => !!user?.permissions;
export const canView = (user, mod) => !user?.permissions || !mod || user.permissions[mod] === "view" || user.permissions[mod] === "edit";
export const canEdit = (user, mod) => !user?.permissions || !mod || user.permissions[mod] === "edit";
